/**
 * SecureSystemHealthPage - Secure system health monitoring
 *
 * Surfaces the SecureSystemHealthDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides security-focused system health monitoring with threat detection.
 *
 * Route: /admin/secure-health
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconShieldCheck } from '@tabler/icons-react';

import { SecureSystemHealthDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function SecureSystemHealthPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="green">
            <IconShieldCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Secure System Health</Title>
            <Text size="sm" c="dimmed">
              Security-focused system health monitoring and threat detection
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <SecureSystemHealthDashboard />
    </Container>
  );
}

export default SecureSystemHealthPage;
